import { Box, Link, paletteColors, Typography } from '@evaneos/b2b-ui';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { useGetDossierData } from '../../../../resources/dossier/queries';
import { DossierId, MarketCode } from '../../../../resources/dossier/types';
import { useGetTrackedTripProperties, useTrackEventAmplitude } from '../../../../shared/analytics';

type MarketId = 'fr' | 'it' | 'es' | 'de' | 'nl';

const MARKET_CODE_TO_MARKET_ID: Partial<Record<MarketCode, MarketId>> = {
    FR: 'fr',
    IT: 'it',
    ES: 'es',
    DE: 'de',
    NL: 'nl',
    CH: 'de',
};

const buildAt1SettingsUrl = (marketId: MarketId): string => {
    return `/agency-manager/automated-message-settings?market=${marketId}`;
};

export const AT1CustomizeLink = () => {
    const { formatMessage } = useIntl();
    const { dossierId } = useParams<{ dossierId: DossierId }>();
    const { dossier } = useGetDossierData(dossierId) || {};
    const { trackEvent } = useTrackEventAmplitude();
    const trackedTripProperties = useGetTrackedTripProperties(dossierId);

    const marketCode = dossier?.project?.marketCode;
    const marketId = marketCode ? MARKET_CODE_TO_MARKET_ID[marketCode] : undefined;

    if (!marketId) return null;

    const settingsUrl = buildAt1SettingsUrl(marketId);

    const handleClick = () => {
        trackEvent((ampli, defaultProperties) => {
            ampli.at1CustomizeLinkClicked({
                ...defaultProperties,
                ...trackedTripProperties,
            });
        });
    };

    return (
        <Box
            sx={{
                backgroundColor: paletteColors.blue[100],
                borderRadius: 2,
                px: 3,
                py: 2,
                mt: 1,
                mb: 3,
            }}
        >
            <Typography variant="body2">
                {formatMessage({ id: 'discussion.at1_auto.customize_link.text' })}{' '}
                <Link
                    href={settingsUrl}
                    target="_blank"
                    onClick={handleClick}
                    sx={{ fontWeight: 700 }}
                >
                    {formatMessage({ id: 'discussion.at1_auto.customize_link.cta' })}
                </Link>
            </Typography>
        </Box>
    );
};
